import axios from 'axios'

const API_BASE = process.env.REACT_APP_NEXTERA_API

export interface ViewpointFlatImage {
  id: number
  public_id: string
  sub_point_id: number
  image_s3_key: string
  image_url: string
  taken_on: string
  registered_on?: string
}

export const fetchViewpointFlatImages = async (
  projectId: string,
  floorCode: string,
): Promise<ViewpointFlatImage[]> => {
  const res = await axios.get(
    `${API_BASE}/project/${projectId}/floor/${floorCode}/viewpoint-flat-images`,
  )
  return res.data?.data ?? res.data ?? []
}

export const fetchViewpointFlatImagePresignedPut = async (
  projectId: string,
  floorCode: string,
  subPointId: number,
  fileName: string,
  contentType: string,
): Promise<{ presigned_url: string; s3_key: string }> => {
  const res = await axios.get(
    `${API_BASE}/project/${projectId}/floor/${floorCode}/viewpoint-flat-images/presigned-put`,
    {
      params: {
        sub_point_id: subPointId,
        file_name: fileName,
        content_type: contentType,
      },
    },
  )
  return res.data?.data ?? res.data
}

export const registerViewpointFlatImage = async (
  projectId: string,
  floorCode: string,
  payload: {
    sub_point_id: number
    s3_key: string
    taken_on: string
  },
): Promise<ViewpointFlatImage> => {
  const res = await axios.post(
    `${API_BASE}/project/${projectId}/floor/${floorCode}/viewpoint-flat-images/register`,
    payload,
  )
  return res.data?.data ?? res.data
}

export const uploadViewpointFlatImageToS3 = async (
  presignedUrl: string,
  file: File,
  contentType: string,
): Promise<void> => {
  await axios.put(presignedUrl, file, {
    headers: {
      'Content-Type': contentType,
    },
    transformRequest: [
      (data, headers) => {
        if (headers) {
          delete headers.Authorization
          delete headers.common?.Authorization
        }
        return data
      },
    ],
  })
}
